<template> 
  <div style="background-color:white;min-height:500px">
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <img src="@/assets/products/agriculture_1.jpg" alt="" height="400" />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <div style="padding-top:80px;padding-left:0%;">
          <div>
            <p style="font-size:36px;padding:0px;margin:0px;font-weight:200;font-family:Roboto">Agricultural Insurance</p>
            
          </div>
          <div style="padding-top:20px">
            <p>Agric Insurance Policies are a valuable business risk management tool that provides you with financial protection against production losses caused by natural perils, such as drought, excessive moisture, hail, frost and wind.</p> 
            <p>Taking agriculture insurance is an important part of investment that gives you protection against any misfortune owing to unpredictable natural disasters.</p>
          </div>
          <div style="padding-left:25%;padding-top:15px">
            <v-btn
              color="primary"
              rounded
              outlined
              large
              @click="openDrawer(0)"        
            >
              Get a Quote
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    

  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'AgricultureInsurance',
    components: {
      
    },
    data() {
      return {
        
      }
    },
    methods: {
      openDrawer(index){
        this.components.nav_drawer.product_index=index;
        this.components.nav_drawer.mini_variant=false;
        this.components.nav_drawer.expand_on_hover=false;
        
      },
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components"
      })
    } 
  }
</script>

